import { useLocation } from "react-router-dom";
import  vehicles  from "../../services/DataFiles/Vehicles/vehicles.mjs";
import { BackButton } from "../../components/Reusable/resuable";
import "./mainService.scss";
export default function Catalog() {
    const location = useLocation();
    const urls = new URLSearchParams(location.search);
    var index = parseInt(urls.get("id") || '0');
    var type= urls.get("type")||"cranes";
    return <>
    <BackButton name="Back"/>
    <div className={`catalog ${vehicles[type][index].products.length>3?'':'setheight'}`} >
        {
           vehicles[type][index].products.map((item, i) => {
                return <div className="sflippingCard">
                    <div className="flipcard">
                        <div className={`back`}>
                            <h4>{item.name}</h4>
                            {type==="cranes"?<div className="information">
                                <div className="block">
                                    <span>No. of Cranes</span>
                                    <span>{item.quantity}</span>
                                </div>
                                <div className="block">
                                    <span>Capacity</span>
                                    <span>{item.capacity}</span>
                                </div>
                                <div className="block">
                                    <span>Boom length</span>
                                    <span>{item.boomlength}</span>
                                </div>
                            </div>:<span/>}
                            {type==="trailers"?<div className="information">
                                <div className="block">
                                    <span>No. of Trailers</span>
                                    <span>{item.quantity}</span>
                                </div>
                                <div className="block">
                                    <span>Capacity</span>
                                    <span>{item.capacity}</span>
                                </div>
                                <div className="block">
                                    <span>Type</span>
                                    <span>{item.type}</span>
                                </div>
                            </div>:<span/>}
                            {type==="axles" || type==="lifts"?<div className="information">
                                <div className="block">
                                    <span>No. of Axles</span>
                                    <span>{item.quantity}</span>
                                </div>
                                <div className="block">
                                    <span>Capacity</span>
                                    <span>{item.capacity}</span>
                                </div>
                                <div className="block">
                                    <span>Type</span>
                                    <span>{item.details}</span>
                                </div>
                            </div>:<span/>}
                            {item.pdf===undefined?<span/>:<div className="button" onClick={() => window.open(item.pdf)}>Download Load Chart</div>}
                        </div>
                        <div className="front">
                            <img src={item.Image} alt="logo" />
                            <span className="para text-center">{item.name}</span>
                        </div>
                    </div>
                </div>
            })
        }
    </div>
    </>
}